module.exports = __webpack_public_path__ + "img/email_block.e443fc37.png";